import { PERMISSIONS } from '@/lib/permissions'

/**
 * The notification screens.
 *
 * `notificationsRoutes` describes what to register and what each screen is gated on, so the router
 * can be wired without reading the tree. Nothing here reaches into the router itself.
 */
export { NotificationOutboxPage } from './outbox'

export interface NotificationsRouteDescriptor {
  path: string
  componentName: string
  permission: string
  phoneBehaviour: 'adapts' | 'refuses'
}

export const notificationsRoutes: NotificationsRouteDescriptor[] = [
  {
    path: '/notifications',
    componentName: 'NotificationOutboxPage',
    // Reading the outbox, not sending from it. Sending by hand is a separate code and a separate
    // screen that does not exist yet.
    permission: PERMISSIONS.notifications.outboxView,
    // Adapts. It is a read screen somebody opens when a customer rings to say they were not told,
    // and that call is as likely to be taken on a phone as at a desk. Nothing on it keys an amount.
    phoneBehaviour: 'adapts',
  },
]
